// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SSdC","newExpiryDate":"styles_newExpiryDate__FUekg","footer":"styles_footer__1uinj"};